import { navigate } from 'gatsby'
import React, { useEffect } from 'react'
import * as Styles from '../contact/index.module.scss'
import { ContactPageTitle } from '@/components/contact/contact-page-title'
import { DemoContainer } from '@/components/contact/demo-container'
import { DemoForm } from '@/components/form/demo-form'
import { Layout } from '@/components/general/layout'
import { Seo } from '@/components/general/seo'
import { pagesPath } from '@/lib/pagesPath'
import { useFormStorage } from '@/lib/use-form-storage'

const DemoPage = ({ location }) => {
  const { getFormStorage, setFormStorage, cleanFormStorage } = useFormStorage()
  const formState = getFormStorage()

  useEffect(() => {
    if (formState) {
      return () => cleanFormStorage()
    }
  }, [])
  return (
    <Layout location={location}>
      <Seo
        title="無料デモのお申し込み"
        description="クラウド決算開示管理サービス【Uniforce】の無料デモ体験をご希望の方は、こちらからお申し込みいただけます。サービスの操作感や、各機能を実際の画面を見ながらご確認いただけます。"
      />
      <ContactPageTitle
        title="無料デモのお申し込み"
        en="DEMONSTRATION"
        readText={
          <div className={Styles.readText}>
            「Uniforceを試したい」、 「実際の画面を見たい」という方に 、
            <br className="pc" />
            無料でサービスの使用感を体験いただける
            <br className="pc" />
            デモンストレーションを 実施しております。
          </div>
        }
        className={Styles.contactPageTitle}
      />

      <div className={Styles.container}>
        <DemoForm
          className={Styles.form}
          initFormState={{
            ...formState,
            agree_flag: false,
          }}
          submitHandler={async (state) => {
            setFormStorage(state)
            await navigate(pagesPath.demo.confirmation.$url())
          }}
        />
        <DemoContainer />
      </div>
    </Layout>
  )
}

export default DemoPage
